import instance from '../utils/axios';

class DealerOrderService {

    async getQualityInspectionList(pageIndex, keyword, startTime, endTime) {
        // eslint-disable-next-line no-debugger
        return await instance.post('/erp/radOrder/getQualityInspectionList', {
            startTime: startTime,
            endTime: endTime,
            pageSize: 10,
            pageIndex: pageIndex,
            fuzzySearch: keyword,
            searchField_string_serialNumber: keyword,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'createTime',
            sort: 'desc',
            dictionaryNames: 'status.dict_form_workflow_instance_status,staffId.base_staff' +
                ',workshopId.erp_workshop,procedureId.erp_procedure' +
                ',inspectionContent.dict_inspection_content,inspectionMethod.dict_inspection_method'
        });
    }

}
export default new DealerOrderService();